import DataTable, { Column } from "../../../components/DataTable";
import ToggleSwitch from "../../../components/ToggleSwitch";
import { useEditMode } from "../../../context/EditModeContext";
import useConfirmToast from "../../../util/hooks/useConfirmToast";
import { useLocation, useParams } from "react-router-dom";
import { Feature } from "../../../types/schoolBranchType";
import { toast } from "sonner";
import StaffApis from "../../../api/staffApis";

export default function Permissions({
  staffId,
  features,
  onRefresh,
}: {
  staffId;
  features: Feature[];
  onRefresh?: () => Promise<void>;
}) {
  const { isEditing } = useEditMode();
  const { confirm, modal } = useConfirmToast();
  const location = useLocation();
  // const { staffId } = useParams<{ staffId: string }>();
  // const numericStaffId = Number(staffId);
  const tab = new URLSearchParams(location.search).get("tab");

  const shouldHideLabel =
    location.pathname === "/view-profile" && tab === "Permissions";

  const columns: Column<Feature>[] = [
    {
      label: "SL NO.",
      accessor: "featuresId",
      render : (_,index) => (
        <p>{index + 1}</p>
      )
    },
    {
      label: "Feature List",
      accessor: "featureList",
      searchable: true,
      render: (item) => (
        <div className="font-bold text-sm text-neutral-400">
          {item.featuresName}
        </div>
      ),
    },
    {
      label: "View Only",
      accessor: "viewOnly",
      searchable: false,
      render: (item) => (
        <ToggleSwitch
          defaultChecked={item.active}
          disabled={!isEditing}
          confirmToggle={(next) =>
            confirm(
              next
                ? "Are you sure you want to enable View access?"
                : "Are you sure you want to disable View access? This will also remove Edit access.",
              { confirmText: "yes" },
            )
          }
          onToggle={async (next) => {
            try {
              await StaffApis.toggleFeature(
                staffId,
                item.featuresId,
                false,
                next,
              );

              if (onRefresh) await onRefresh();

              toast.success("Feature updated successfully");
            } catch {
              toast.error("Failed to update feature");
            }
          }}
        />
      ),
    },
    {
      label: "Can Edit / Manage",
      accessor: "canEdit",
      searchable: false,
      render: (item) => (
        <ToggleSwitch
          defaultChecked={item.canEdit}
          disabled={!isEditing}
          confirmToggle={(next) =>
            confirm(
              next
                ? "Are you sure you want to enable Edit access?"
                : "Are you sure you want to disable Edit access?",
              { confirmText: "yes" },
            )
          }
          onToggle={async (next) => {
            try {
              await StaffApis.toggleFeature(
                staffId,
                item.featuresId,
                next, // canEdit
                true, // active must be true if edit is enabled
              );

              if (onRefresh) {
                await onRefresh();
              }

              toast.success("Feature updated successfully");
            } catch {
              toast.error("Failed to update feature");
            }
          }}
        />
      ),
    },
  ];

  return (
    <div className="px-4 md:px-9 py-7 flex flex-col gap-8">
      {!shouldHideLabel && (
        <label className="text-xs font-medium text-error-500">
          *Only the features enabled here will appear for your staff
        </label>
      )}
      <DataTable columns={columns} data={features} />
      {modal}
    </div>
  );
}
